import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import PageHeader from '@quintoandar/cozy-core/AppBar/PageHeader';
import CozyLogo from '@quintoandar/cozy-core/CozyLogo';
import Box from '@quintoandar/cozy-core/Box';
import IconButton from '@quintoandar/cozy-core/IconButton';
import Typography from '@quintoandar/cozy-core/Typography';

import Menu from 'components/Menu/Loadable';
import ROUTES from 'routes/constants';
import { getProductName } from 'Base/i18n/brand';

const AppBarDesktop = ({ title, tabs, navigationIcon, subtitle, pageActions }) => (
  <>
    <PageHeader
      fixed
      logo={
        <Link to={ROUTES.BASE_PATH}>
          <CozyLogo product={getProductName()} />
        </Link>
      }
      primaryItem={<Menu />}
    />

    {title && (
      <Box mx="auto" mt={6} px={2} maxWidth={500}>
        {(navigationIcon || pageActions) && (
          <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
            {navigationIcon ? <IconButton {...navigationIcon} /> : <Box />}
            {pageActions}
          </Box>
        )}

        <Typography level="heading">{title}</Typography>

        {subtitle && (
          <Box>
            <Typography level="bodyLarge">{subtitle}</Typography>
          </Box>
        )}

        {tabs && <Box mt={2}>{tabs}</Box>}
      </Box>
    )}
  </>
);

AppBarDesktop.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  tabs: PropTypes.node,
  navigationIcon: PropTypes.object,
  pageActions: PropTypes.node,
};

export default AppBarDesktop;
